import angular from 'angular';

angular
    .module('home')

    .controller('HomeCtrl', [
        'IndicatorService',
        function(IndicatorService) {
            var vm = this;

            vm.indicators = [
                {
                    id: 'envelope_waiting_confirm',
                    label: 'home.indicator.envelope_waiting_confirm',
                    value: 'N/A',
                    glyph: 'glyphicon-warning-sign',
                    big: false,
                    linkState: "envelopes({tabName: 'search', specificForm: 'envelope_waiting_confirm'})"
                },
                {
                    id: 'indexfile_overdue',
                    label: 'home.indicator.indexfile_overdue',
                    value: 'N/A',
                    glyph: 'glyphicon-warning-sign',
                    big: false,
                    linkState: "batches({tabName: 'indexfileOverdue'})"
                },
                {
                    id: 'batch_rejected',
                    label: 'home.indicator.batch_rejected',
                    value: 'N/A',
                    glyph: 'glyphicon-warning-sign',
                    big: false,
                    linkState: "batches({tabName: 'search', specificForm: 'batch_rejected'})"
                },
                {
                    id: 'message_sent',
                    label: 'home.indicator.message_sent',
                    value: 'N/A',
                    glyph: 'glyphicon-warning-sign',
                    big: false,
                    linkState: "messages({specificForm: 'message_sent'})"
                },
                {
                    id: 'envelope_created',
                    label: 'home.indicator.envelope_created',
                    value: 'N/A',
                    glyph: 'glyphicon-star',
                    big: false,
                    linkState: "envelopes({tabName: 'search', specificForm: 'envelope_created'})"
                },
                {
                    id: 'folder_created',
                    label: 'home.indicator.folder_created',
                    value: 'N/A',
                    glyph: 'glyphicon-star',
                    big: false,
                    linkState: "folders({tabName: 'search', specificForm: 'folder_created'})"
                },
                {
                    id: 'batch_platform_created',
                    label: 'home.indicator.batch_platform_created',
                    value: 'N/A',
                    glyph: 'glyphicon-star',
                    big: false,
                    linkState: "batches({tabName: 'search', specificForm: 'batch_platform_created'})"
                },
                {
                    id: 'batch_quali_created',
                    label: 'home.indicator.batch_quali_created',
                    value: 'N/A',
                    glyph: 'glyphicon-star',
                    big: false,
                    linkState: "batches({tabName: 'search', specificForm: 'batch_quali_created'})"
                },
                {
                    id: 'message_created',
                    label: 'home.indicator.message_created',
                    value: 'N/A',
                    glyph: 'glyphicon-star',
                    big: false,
                    linkState: "messages({specificForm: 'message_created'})"
                },
                {
                    id: 'envelope_orphan',
                    label: 'home.indicator.envelope_orphan',
                    value: 'N/A',
                    glyph: 'glyphicon-cog',
                    big: true,
                    linkState: "envelopes({tabName: 'waiting'})"
                },
                {
                    id: 'lad_send_failed',
                    label: 'home.indicator.lad_send_failed',
                    value: '0',
                    glyph: 'glyphicon-share',
                    big: true,
                    linkState: "batches({tabName: 'rebroadcast', specificForm: 'error_deposit'})"
                },
                {
                    id: 'batch_unmatched',
                    label: 'home.indicator.batch_unmatched',
                    value: 'N/A',
                    glyph: 'glyphicon-question-sign',
                    big: true,
                    linkState: "batches({tabName: 'unknownBatchRef', specificForm:'errors'})"
                }
            ];

            vm.today = new Date();

            vm.gotoDetails = gotoDetails;

            var gotoDetails = function(/*indicatorId*/) {
                alert('Fonction à venir...');
            };

            (function() {
                // init
                angular.forEach(vm.indicators, function(indicator) {
                    // Obtention de la valeur de l'indicateur
                    IndicatorService.get(
                        { indicatorName: indicator.id },
                        function(indicatorValue) /* success */ {
                            indicator.value = indicatorValue.second;
                        },
                        function() /* error*/ {
                            indicator.value = 'N/A';
                        }
                    );
                });
            })();
        }
    ]);
